import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const BannerSlider = ({ banners, isDark }) => {
  const [current, setCurrent] = useState(0);
  const total = banners.length;

  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % total);
  }, [total]);

  const prev = () => {
    setCurrent(prev => (prev - 1 + total) % total);
  };

  // Auto-slide every 4 seconds
  useEffect(() => {
    if (total <= 1) return;
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [next, total]);

  const handleClick = (banner) => {
    if (banner.linkUrl) {
      if (banner.linkUrl.startsWith('http')) {
        window.open(banner.linkUrl, '_blank');
      } else {
        window.location.href = banner.linkUrl;
      }
    }
  };

  if (total === 0) return null;

  return (
    <div className="relative mb-6 rounded-2xl overflow-hidden" data-testid="banner-slider">
      <div
        className="flex transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {banners.map((banner) => (
          <div
            key={banner.id}
            className={`w-full shrink-0 ${banner.linkUrl ? 'cursor-pointer' : ''}`}
            onClick={() => handleClick(banner)}
          >
            <img
              src={`${API_BASE}${banner.imageUrl}`}
              alt="Bannière promotionnelle"
              className="w-full h-36 sm:h-44 object-cover"
              data-testid={`banner-image-${banner.id}`}
            />
          </div>
        ))}
      </div>

      {total > 1 && (
        <>
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full flex items-center justify-center transition-opacity bg-black/40 hover:bg-black/60 text-white"
            data-testid="banner-prev"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full flex items-center justify-center transition-opacity bg-black/40 hover:bg-black/60 text-white"
            data-testid="banner-next"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5">
            {banners.map((_, idx) => (
              <button
                key={idx}
                onClick={(e) => { e.stopPropagation(); setCurrent(idx); }}
                className="w-2 h-2 rounded-full transition-all"
                style={{
                  backgroundColor: idx === current ? '#fff' : 'rgba(255,255,255,0.4)',
                  transform: idx === current ? 'scale(1.3)' : 'scale(1)'
                }}
                data-testid={`banner-dot-${idx}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default BannerSlider;
